import { WEB_ROUTES } from "@upsquad/shared";

export const EMAIL_ROUTES = {
	UNSUBSCRIBE: WEB_ROUTES.UNSUBSCRIBE,
} as const;
